import { memo } from 'react'
import PropTypes from 'prop-types'
import { FixedSizeList as List, areEqual } from 'react-window'
import memoize from 'memoize-one'

import TeamSelectionRow from 'components/rbac-settings/TeamSelectionRow'
import theme from 'theme'

export default function TeamSelect({
  teams,
  onTeamClick,
  multiSelect,
  selectedTeams = []
}) {
  return (
    <div css={{ display: 'flex', flexDirection: 'column' }}>
      <TeamList
        multiSelect={multiSelect}
        selectedTeams={selectedTeams}
        teams={teams}
        onTeamClick={onTeamClick}
      />
    </div>
  )
}

TeamSelect.propTypes = {
  onTeamClick: PropTypes.func,
  multiSelect: PropTypes.bool,
  selectedTeams: PropTypes.array,
  teams: PropTypes.array
}

const createItemData = memoize(
  (teams, onTeamClick, selectedTeams, multiSelect) => ({
    teams,
    onTeamClick,
    selectedTeams,
    multiSelect
  })
)

const Row = memo(function Row({
  data: { teams, selectedTeams, multiSelect, onTeamClick },
  index,
  style
}) {
  const team = teams[index]
  return (
    <TeamSelectionRow
      css={style}
      multiSelect={multiSelect}
      selectedTeams={selectedTeams}
      team={team}
      onTeamClick={onTeamClick}
    />
  )
},
areEqual)

Row.propTypes = {
  onTeamClick: PropTypes.func,
  selectedTeams: PropTypes.array,
  multiSelect: PropTypes.bool,
  teams: PropTypes.array
}

function TeamList({
  teams,
  onTeamClick,
  selectedTeams,
  multiSelect = true,
  height = theme.space[9]
}) {
  const itemData = createItemData(
    teams,
    onTeamClick,
    selectedTeams,
    multiSelect
  )
  return (
    <List
      css={
        // Only show border if list is scrollable
        teams.length * 89 >= theme.space[9] && {
          border: theme.border.base,
          borderRadius: theme.borderRadius[0]
        }
      }
      height={height}
      itemCount={teams.length}
      itemData={itemData}
      itemSize={89}
      width="100%"
    >
      {Row}
    </List>
  )
}

TeamList.propTypes = {
  onTeamClick: PropTypes.func,
  selectedTeams: PropTypes.array,
  multiSelect: PropTypes.bool,
  height: PropTypes.number,
  teams: PropTypes.array
}
